// src/pages/Companies.js
import React, { useEffect, useState } from 'react';
import FractalList from '../components/FractalList';
import DonutChart from '../components/DonutChart';
import Breadcrumb from '../components/Breadcrumb';
import ChildGrid from '../components/ChildGrid';
import ChildCreationForm from '../components/ChildCreationForm';

function Fractals({ apiToken}) {
    const [selectedFractal, setSelectedFractal] = useState(null);
    const [currentLevel, setCurrentLevel] = useState(null);
    const [breadcrumbPath, setBreadcrumbPath] = useState([]);
    const [niveles, setNiveles] = useState([]);
  
    useEffect(() => {
      const fetchData = async () => {
      }

      fetchData();
    }, [apiToken]);
  
    const handleSelectFractal = (fractal) => {
      setSelectedFractal(fractal);
      setCurrentLevel(fractal);  // Asumimos que fractal tiene una propiedad de nivel raíz
      setBreadcrumbPath([fractal.nombre]);
    };
  
    const handleSelectLevel = (nombre) => {
      const nivel = currentLevel.fractales.find((nivel) => nivel.nombre === nombre);
      if (nivel) {
        niveles.push(currentLevel);
        setCurrentLevel(nivel);
        setBreadcrumbPath([...breadcrumbPath, nivel.nombre]);
      }
    };
  
    const handleBreadcrumbNavigate = (index) => {
      setBreadcrumbPath(breadcrumbPath.slice(0, index + 1));
      setCurrentLevel(niveles[index]);  
    };  
  
    const handleChildCreated = () => {
      setCurrentLevel({ ...currentLevel });
    }
  
    return (
      <div style={{ display: 'flex' }}>
        {/* Columna 1 */}
        <div style={{ flex: 1 }}>
          <FractalList onSelectFractal={handleSelectFractal} />
        </div>
        
        {/* Columna 2 */}
        <div style={{ flex: 1 }}>
          {selectedFractal && (
            <>
            <ChildCreationForm currentLevel={currentLevel} onChildCreated={handleChildCreated} />
            <Breadcrumb path={breadcrumbPath} onNavigate={handleBreadcrumbNavigate} />
            </>
          )}
          {selectedFractal && currentLevel.fractales.length>0 && (
            <DonutChart data={currentLevel.fractales} onSelectLevel={handleSelectLevel} />
          )}
        </div>
  
        {/* Columna 3 */}
        <div style={{ flex: 1 }}>
          {currentLevel && currentLevel.fractales.length>0 && <ChildGrid children={currentLevel.fractales} />}
        </div>
      </div>
    );
  }

export default Fractals;
